import type {
  Percepcao,
  StatusAgendamento,
  StatusLead,
  Temperatura,
} from '@baiocchi/shared'
import { Etiqueta } from '@baiocchi/ui'

import {
  ROTULO_PERCEPCAO,
  ROTULO_STATUS_AGENDAMENTO,
  ROTULO_STATUS_LEAD,
  ROTULO_TEMPERATURA,
  TOM_PERCEPCAO,
  TOM_STATUS_AGENDAMENTO,
  TOM_STATUS_LEAD,
  TOM_TEMPERATURA,
} from '../dominio/rotulos'

/**
 * Etiquetas de domínio.
 *
 * Ficam aqui, e não em `packages/ui`, porque conhecem os enums do lead. O design
 * system não deve saber o que é "venda não realizada" — se soubesse, uma mudança
 * de regra de negócio exigiria alterar o pacote de UI.
 */

export function EtiquetaStatus({ status }: { status: StatusLead }) {
  return <Etiqueta tom={TOM_STATUS_LEAD[status]}>{ROTULO_STATUS_LEAD[status]}</Etiqueta>
}

export function EtiquetaTemperatura({ temperatura }: { temperatura: Temperatura }) {
  return <Etiqueta tom={TOM_TEMPERATURA[temperatura]}>{ROTULO_TEMPERATURA[temperatura]}</Etiqueta>
}

export function EtiquetaPercepcao({ percepcao }: { percepcao: Percepcao }) {
  return <Etiqueta tom={TOM_PERCEPCAO[percepcao]}>{ROTULO_PERCEPCAO[percepcao]}</Etiqueta>
}

export function EtiquetaStatusAgendamento({ status }: { status: StatusAgendamento }) {
  return (
    <Etiqueta tom={TOM_STATUS_AGENDAMENTO[status]}>{ROTULO_STATUS_AGENDAMENTO[status]}</Etiqueta>
  )
}

/**
 * Responsável do lead. `null` vira `SEM RESPONSÁVEL` em destaque — é um lead à
 * espera de atribuição na TELA-02, não um campo vazio, e a diferença precisa
 * aparecer. Quem enxerga esse estado é o SUPERVISOR para cima.
 */
export function EtiquetaResponsavel({
  responsavel,
}: {
  responsavel: { nome: string } | null
}) {
  if (!responsavel) {
    return <Etiqueta tom="atencao">Sem responsável</Etiqueta>
  }
  return <Etiqueta tom="neutro">{responsavel.nome}</Etiqueta>
}

/** Badge `ABORDAGEM {n}` da TELA-02. `0` não renderiza nada. */
export function EtiquetaAbordagem({ tentativas }: { tentativas: number }) {
  if (tentativas <= 0) return null
  return (
    <Etiqueta tom="abordagem" title={`${tentativas} tentativa(s) de contato registrada(s)`}>
      Abordagem {tentativas}
    </Etiqueta>
  )
}

/** Lead com retorno vencido (RN-25A). Derivado no servidor, nunca aqui. */
export function EtiquetaAtrasado({ atrasado }: { atrasado: boolean }) {
  if (!atrasado) return null
  return <Etiqueta tom="perigo">Atrasado</Etiqueta>
}
